import { useCallback, useEffect, useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux"
import debounce from 'lodash.debounce';
import { CloseButton, Box, InputGroup, InputLeftElement, Input, InputRightElement } from "@chakra-ui/react";
import { FiSearch } from "react-icons/fi";
import ButtonPrimary from "components/button/ButtonPrimary";
import { IoAddCircle } from "react-icons/io5";
import { SET_TO_DEFAULT_RESPONSE, create } from "./../../../store/features/slices/ventaSlice";
import { UPDATE_STOCK_PRODUCT, getByPage as getByPagePro } from "./../../../store/features/slices/productoSlice";
import { addToCart, addToCartWhitBarCode, applyDiscount, getMyCart, removeFromCart, resetMutationResult, resetUserCart, updateCartItemQty } from "./../../../store/features/slices/cartSlice";
import { SET_TO_DEFAULT_RESPONSE_CONSULTA_RENIEC, getByDocumentId } from "./../../../store/features/slices/consultaReniecSlice";
import { uriSerialized } from "utils/uriSerialized";
import { validarDNI } from "utils/Funciones";
import { validarRUC } from "utils/Funciones";
import TablePaginationPos from "./table/TablePaginationPos";
import TableCartItemsPos from "./table/TableCartItemsPos";
import { message } from "utils/Funciones";

const Pos = () => {
    const dispatch = useDispatch();
    const { userToken, user } = useSelector((state) => state.userReducer);
    const {
        responseSuccessCreate,
        isLoading,
    } = useSelector((state) => state.ventaReducer);

    const {
        dataByPage: dataByPagePro,
        totalPage: totalPagePro,
        totalRow: totalRowPro,
        isLoading: isLoadingPro
    } = useSelector((state) => state.productoReducer);

    const {
        isLoading: isLoadingConsultaReniec,
        responseGetByDocumentId
    } = useSelector((state) => state.consultaReniecReducer);

    const {
        isMutation, userCart, numOfCartItems
    } = useSelector((state) => state.cartReducer);

    const [searchTermProductos, setSearchTermProductos] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [state, setState] = useState({
        cliente: {
            dniruc: '',
            nombres: '',
            nombrecompleto: '',
            ap_paterno: '',
            ap_materno: '',
            direccion: '',
            correo: '',
            telefono: '',
            estado: '',
            tipodocumento: '',
        },
        comprobantename: 'notadeventa',
        comprobantecode: 'D2',
        codigobarras: '',
        vendedor: '',
        metodopago: ''
    })

    const setDefaultState = () => {
        setState({
            ...state,
            cliente: {
                dniruc: '',
                nombres: '',
                nombrecompleto: '',
                ap_paterno: '',
                ap_materno: '',
                direccion: '',
                correo: '',
                telefono: '',
                estado: '',
                tipodocumento: '',
            },
            comprobantename: 'notadeventa',
            comprobantecode: 'D2',
            codigobarras: '',
            vendedor: '',
            metodopago: ''
        })
    }

    useEffect(() => {
        const queryOptions = {
            userId: userToken && user.id,
        }
        const query = queryOptions ? "?" + uriSerialized(queryOptions) : ""
        if (isMutation.success) {
            setState({ ...state, codigobarras: '' })
            dispatch(resetMutationResult());
            dispatch(getMyCart({ query: query, token: userToken }))
        } else {
            dispatch(getMyCart({ query: query, token: userToken }))
        }
    }, [dispatch, isMutation.success])

    const onDecreased = (itemId, productId) => {
        const formData = {
            userId: userToken && user.id,
            itemId: itemId,
            quantity: -1,
            productId: productId
        }
        dispatch(updateCartItemQty({ formData: formData, token: userToken }))
    }

    const onIncreased = (itemId, productId) => {
        const formData = {
            userId: userToken && user.id,
            itemId: itemId,
            quantity: 1,
            productId: productId
        }
        dispatch(updateCartItemQty({ formData: formData, token: userToken }))
    }

    const onRemoveFromCart = (itemId) => {
        dispatch(removeFromCart({ itemId: itemId, userId: userToken && user.id, token: userToken }))
    }

    const onApplyDiscount = (descuento) => {
        const formData = {
            userId: userToken && user.id,
            descuento: descuento
        }
        dispatch(applyDiscount({ formData: formData, token: userToken }))
    }

    const handleAgregarAlCarrito = (row) => {
        const formData = {
            userId: userToken && user.id,
            productId: row._id,
            quantity: 1
        }
        dispatch(addToCart({ formData: formData, token: userToken }))
    }

    const handleAddToCartWhitBarCode = (e) => {
        console.log(e.target.value)
        setState({ ...state, codigobarras: e.target.value })
        if (e.target.value.trim().length === 9) {
            const formData = {
                userId: userToken && user.id,
                codigoIterno: e.target.value.trim()
            }
            dispatch(addToCartWhitBarCode({ formData: formData, token: userToken }))
        }
    }

    const onSubmitConsultarReniec = async () => {
        if (state.cliente.tipodocumento.trim().length === 0) {
            message('Selecciona un tipo de documento', 'error', '5')
        } else if (state.cliente.tipodocumento === 'DNI' && !validarDNI(state.cliente.dniruc)) {
            message('DNI inválido', 'error', '5')
        } else if (state.cliente.tipodocumento === 'RUC' && !validarRUC(state.cliente.dniruc)) {
            message('RUC inválido', 'error', '5')
        } else {
            const queryOptions = {
                number: state.cliente.dniruc,
                type: state.cliente.tipodocumento,
            }
            const query = queryOptions ? "?" + uriSerialized(queryOptions) : ""
            await dispatch(getByDocumentId({ query: query, token: userToken }))
        }
    }

    useEffect(() => {
        if (responseGetByDocumentId) {
            if (state.cliente.tipodocumento === 'RUC') {
                setState({
                    ...state, cliente:
                    {
                        ...state.cliente,
                        nombrecompleto: responseGetByDocumentId.razonsocial,
                        direccion: responseGetByDocumentId.direccion,
                        departamento: responseGetByDocumentId.departamento,
                        provincia: responseGetByDocumentId.provincia,
                        distrito: responseGetByDocumentId.distrito,
                        estado: responseGetByDocumentId.estado,
                        condicion: responseGetByDocumentId.condicion,
                    }
                })
            } else {
                setState({
                    ...state, cliente:
                    {
                        ...state.cliente,
                        nombrecompleto: responseGetByDocumentId.apellidoPaterno + ' ' + responseGetByDocumentId.apellidoMaterno + ' ' + responseGetByDocumentId.nombres,
                        nombres: responseGetByDocumentId.nombres,
                        ap_paterno: responseGetByDocumentId.apellidoPaterno,
                        ap_materno: responseGetByDocumentId.apellidoMaterno,
                        direccion: responseGetByDocumentId.direccion
                    }
                })
            }
        }
        dispatch(SET_TO_DEFAULT_RESPONSE_CONSULTA_RENIEC())
    }, [responseGetByDocumentId])

    const onSubmitRegistrar = async (e) => {
        e.preventDefault();

        if (!state.metodopago) {
            message("Debes seleccionar un método de pago.", "error", 3);
            return;
        }

        const formData = new FormData();
        state.userId = userToken && user.id
        formData.append('data', JSON.stringify(state));
        await dispatch(create({ formData: formData, token: userToken }));
    }

    useEffect(() => {
        if (responseSuccessCreate) {
            message(responseSuccessCreate.message, 'success', 5)

            /*const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            iframe.src = responseSuccessCreate.data.sunat.pdf["A5"];
            document.body.appendChild(iframe);
            iframe.onload = () => {
                iframe.contentWindow.print();
            };*/
            dispatch(UPDATE_STOCK_PRODUCT(responseSuccessCreate.cart))
            dispatch(resetUserCart(responseSuccessCreate.cartClear))
            setDefaultState()
            //registrar.onClose()
            dispatch(SET_TO_DEFAULT_RESPONSE())
        }
    }, [responseSuccessCreate])

    const fetchDataPro = useCallback(
        (pageSize, pageIndex, search) => {
            const queryOptions = {
                page: Number(pageIndex) - 1,
                limit: Number(pageSize),
                search: search,
                order: ""
            }
            const query = queryOptions ? "?" + uriSerialized(queryOptions) : ""
            dispatch(getByPagePro({ query: query, token: userToken }))
        },
        []
    )

    useEffect(() => {
        fetchDataPro(pageSize, currentPage, searchTermProductos)
    }, [currentPage, pageSize, searchTermProductos])

    const onChangeSearchTermProductos = e => {
        setSearchTermProductos(e.target.value);
    };

    const onChangeSearchTermClearProductos = e => {
        setSearchTermProductos("");
        document.getElementById("searchProductos").value = "";
    };

    const debounceSearchTermProductos = useMemo(() => debounce(onChangeSearchTermProductos, 700), []);

    return (
        <div className="mt-4 md:mt-0">
            <div className="mt-3 md:mt-8">
                <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-65-35 gap-2 !z-[1004]">
                    <div className="overflow-y-scroll h-[calc(100vh-85px)] w-full">
                        <div className="min-h-[78vh] mt-4 md:mt-0">
                            <div className="sticky z-30 w-full flex items-center justify-end bg-white dark:!bg-navy-800 p-2 rounded-xl shadow-xl shadow-gray-200 dark:shadow-none">
                                <div className="relative flex h-[61px] w-[calc(100%-55px)] flex-grow items-center gap-2 rounded-full bg-white px-0 py-2 dark:!bg-navy-800">
                                    <InputGroup className="!w-full md:!w-[325px]">
                                        <InputLeftElement pointerEvents="none" className="!mt-1 !ml-1">
                                            <FiSearch size={24} className="text-navy-500 dark:text-navy-300" />
                                        </InputLeftElement>
                                        <Input size='lg' id="searchProductos" onChange={debounceSearchTermProductos} type="text" placeholder={`Buscar ${totalRowPro} productos y servicios...`} className="flex w-full items-center justify-center !rounded-xl border !bg-lightPrimary 
            dark:!bg-navy-900 !text-sm !ring-none focus:!ring-brand-500 
            focus:!border-brand-500 dark:focus:!ring-brand-400 dark:focus:!border-brand-400 
            !outline-none !border-gray-200 dark:!border-white/10 dark:text-white" />
                                        <InputRightElement className="!mt-1">
                                            <CloseButton onClick={onChangeSearchTermClearProductos} size='md' className={`mr-2 ${searchTermProductos.trim().length > 0 ? 'scale-100' : 'scale-0'} transition-all duration-500 text-navy-500 dark:text-navy-300`} />
                                        </InputRightElement>
                                    </InputGroup>
                                </div>
                            </div>
                            <div className="mt-5 grid grid-cols-1">
                                <Box>
                                    <TablePaginationPos
                                        loading={isLoadingPro}
                                        data={dataByPagePro}
                                        currentPage={currentPage}
                                        totalPages={totalPagePro}
                                        onPageChange={setCurrentPage}
                                        pageSize={pageSize}
                                        onPageSizeChange={setPageSize}
                                        handleAgregarAlCarrito={handleAgregarAlCarrito}
                                    />
                                </Box>
                            </div>
                        </div>
                    </div>
                    <div className="overflow-y-scroll h-[calc(100vh-85px)] w-full">
                        {/*<div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-2">
                                <div onClick={() => setState({ ...state, comprobantename: 'factura', comprobantecode: '01' })}
                                    className={`w-full font-semibold text-black dark:text-white p-3 text-center bg-neutral-100 dark:bg-navy-900 cursor-pointer rounded-lg shadow-neutral-300 shadow-lg dark:shadow-none ${state.comprobantename === 'factura' && '!bg-brand-500 dark:!bg-brand-400 !text-white'}`}>
                                    Factura
                                </div>
                                <div onClick={() => setState({ ...state, comprobantename: 'boleta', comprobantecode: '03' })}
                                    className={`w-full font-semibold text-black dark:text-white p-3 text-center bg-neutral-100 dark:bg-navy-900 cursor-pointer rounded-lg shadow-neutral-300 shadow-lg dark:shadow-none ${state.comprobantename === 'boleta' && '!bg-brand-500 dark:!bg-brand-400 !text-white'}`}>
                                    Boleta
                                </div>
                                <div onClick={() => setState({ ...state, comprobantename: 'notadeventa', comprobantecode: 'D2' })}
                                    className={`w-full font-semibold text-black dark:text-white p-3 text-center bg-neutral-100 dark:bg-navy-900 cursor-pointer rounded-lg shadow-neutral-300 shadow-lg dark:shadow-none ${state.comprobantename === 'notadeventa' && '!bg-brand-500 dark:!bg-brand-400 !text-white'}`}>
                                    Nota de venta
                                </div>
                    </div>*/}
                        <form className="w-full" onSubmit={onSubmitRegistrar}>
                            <div className="flex flex-wrap">

                                {/*<AutoComplete
                                        autoFocus={true}
                                        extra="w-full md:w-4/12 mb-3 p-2"
                                        label="Tipo de documento"
                                        data={[
                                            { tipo: 'DNI' }, { tipo: 'RUC' },
                                            { tipo: 'CARNET DE EXTRANJERIA' }, { tipo: 'PASAPORTE' }
                                        ]}
                                        value={state.cliente.tipodocumento}
                                        required={((userCart.cart?.cartItems?.length > 0 && userCart.cart?.totalPrice >= 700 && state.comprobantename !== "notadeventa") || state.comprobantename === "factura") ? true : false}
                                        labelProp="tipo"
                                        valueProp="tipo"
                                        onChange={(val) => setState({ ...state, cliente: { ...state.cliente, tipodocumento: val } })}
                                    />

                                    <InputField
                                        variant="input"
                                        required={((userCart.cart?.cartItems?.length > 0 && userCart.cart?.totalPrice >= 700 && state.comprobantename !== "notadeventa") || state.comprobantename === "factura") ? true : false}
                                        disabled={isLoadingConsultaReniec}
                                        iconright={<IoSearch className="text-brand-600 dark:text-brand-400" size={!24} />}
                                        onClickIconRight={onSubmitConsultarReniec}
                                        extra="w-full md:w-4/12 mb-3 p-2"
                                        label="Número de documento"
                                        placeholder="Número de documento"
                                        id="dniruc"
                                        type="text"
                                        name="dniruc"
                                        onChange={(e) => setState({ ...state, cliente: { ...state.cliente, dniruc: e.target.value } })}
                                        value={state.cliente.dniruc}
                                    />

                                    <InputField
                                        variant="input"
                                        required={((userCart.cart?.cartItems?.length > 0 && userCart.cart?.totalPrice >= 700 && state.comprobantename !== "notadeventa") || state.comprobantename === "factura") ? true : false}
                                        iconLoading={<Spinner size="w-[25px] h-[25px]" />}
                                        disabled={isLoadingConsultaReniec}
                                        extra="w-full md:w-4/12 mb-3 p-2"
                                        label="Nombre o razón social"
                                        placeholder=""
                                        id="nombrecompleto"
                                        type="text"
                                        name="nombrecompleto"
                                        onChange={(e) => setState({ ...state, cliente: { ...state.cliente, nombrecompleto: e.target.value } })}
                                        value={state.cliente.nombrecompleto}
                                    />

                                    <InputField
                                        variant="input"
                                        required={(userCart.cart?.cartItems?.length > 0 && state.comprobantename === "factura") ? true : false}
                                        extra="w-full md:w-4/12 mb-3 p-2"
                                        label="Dirección"
                                        placeholder="Dirección"
                                        id="direccion"
                                        type="text"
                                        name="direccion"
                                        onChange={(e) => setState({ ...state, cliente: { ...state.cliente, direccion: e.target.value } })}
                                        value={state.cliente.direccion}
                                    />

                                    <InputField
                                        variant="input"
                                        iconleft={<FaBarcode size={26} className="text-neutral-700 dark:text-neutral-300 mr-1" />}
                                        extra="w-full md:!w-5/12 mb-1 p-2"
                                        label="Escanear código de barras"
                                        placeholder="Escanear código de barras"
                                        id="codigobarras"
                                        type="text"
                                        name="codigobarras"
                                        onChange={handleAddToCartWhitBarCode}
                                        maxLength={9}
                                        value={state.codigobarras}
                                    />*/}

                                <div className="w-full grid grid-cols-1">
                                    <TableCartItemsPos
                                        userCart={userCart}
                                        onIncreased={onIncreased}
                                        onDecreased={onDecreased}
                                        loading={isMutation.loading}
                                        onRemoveFromCart={onRemoveFromCart}
                                        onApplyDiscount={onApplyDiscount}
                                        metodopagoval={state.metodopago}
                                        onUpdateMetodoPago={(val) => setState({ ...state, metodopago: val })}
                                    />
                                </div>

                                <ButtonPrimary
                                    loadingText={`${state.comprobantecode === '01' || state.comprobantecode === '03' ? 'Esperando respuesta de la SUNAT ...' : 'Guardando datos y generando pdf ...'}`}
                                    isLoading={isLoading}
                                    disabled={userCart.cart?.cartItems?.length > 0 ? false : true}
                                    icon={<IoAddCircle size={28} />}>
                                    Registrar
                                </ButtonPrimary>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div >

    );
};

export default Pos;
